import { Label } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventParticipationStatus } from "../../types/event";
import { ParticipationStatusIcon } from "./ParticipationStatusIcon";

interface Props {
	status: EventParticipationStatus;
}
export const ParticipationStatusLabel: FC<Props> = ({ status }) => {
	const { t } = useTranslation();

	switch (status) {
		case "withParticipation":
			return (
				<Label color="success">
					<ParticipationStatusIcon hasParticipation={true} />
					{t(`eventParticipationStatus.${status}`)}
				</Label>
			);
		case "noParticipation":
			return (
				<Label color="medium">
					<ParticipationStatusIcon hasParticipation={false} />
					{t(`eventParticipationStatus.${status}`)}
				</Label>
			);
		case "none":
			return null;
	}
};
